import script from "./UCGrid.vue?vue&type=script&setup=true&lang=js"
export * from "./UCGrid.vue?vue&type=script&setup=true&lang=js"

import "./UCGrid.vue?vue&type=style&index=0&id=63708ffc&lang=css"

const __exports__ = script;

export default __exports__